import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { CleanPanel as Paper } from "@/ui";

type State = { error?: any };
export default class RootErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = {};

  static getDerivedStateFromError(error: any) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <Box sx={{ p: 3 }}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>Что-то пошло не так</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: "pre-wrap", mb: 2 }}>
              Не удалось открыть интерфейс из-за технической ошибки. Обновите страницу. Несохраненные изменения могут потеряться. Если ошибка повторится, сообщите администратору, в каком разделе она возникла.
            </Typography>
            <Button variant="outlined" onClick={() => window.location.reload()}>Перезагрузить</Button>
          </Paper>
        </Box>
      );
    }
    return this.props.children;
  }
}
